import { firebaseCloudFunctionService } from '@/libs/api';

export const PLAYER_ENDPOINTS = {
  LIST_PLAYERS: '/sortFilterSearchPlayers',
} as const;

export const PlayerServices = {
  sortFilterSearchPlayers: async (request: player.SortFilterSearchPlayersRequest) => {
    const response = await firebaseCloudFunctionService.get<player.PlayersLookupResponse>(
      PLAYER_ENDPOINTS.LIST_PLAYERS,
      request,
    );
    return response;
  },
};
